import { css } from '@emotion/react';
import { theme } from './theme';
import { tokens } from './tokens';

export const rgba = (color: string, opacity: number): string => {
   if (color.startsWith('rgb')) {
      const values = color.match(/\d+/g);
      if (values && values.length >= 3) {
         return `rgba(${values[0]}, ${values[1]}, ${values[2]}, ${opacity})`;
      }
   }
   if (color.startsWith('#')) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
   }
   return color;
};

export const typography = {
   headingXS: css`
      font-size: ${tokens.font.size.md};
      font-weight: ${tokens.font.weight.semibold};
      line-height: ${tokens.font.lineHeight.normal};
   `,
   headingS: css`
      font-size: ${tokens.font.size.lg};
      font-weight: ${tokens.font.weight.semibold};
      line-height: ${tokens.font.lineHeight.normal};
   `,
   headingM: css`
      font-size: ${tokens.font.size.xl};
      font-weight: ${tokens.font.weight.semibold};
      line-height: ${tokens.font.lineHeight.tight};
   `,
   headingL: css`
      font-size: ${tokens.font.size.xxl};
      font-weight: ${tokens.font.weight.bold};
      line-height: ${tokens.font.lineHeight.tight};
   `,
   headingXL: css`
      font-size: ${tokens.font.size['3xl']};
      font-weight: ${tokens.font.weight.bold};
      line-height: ${tokens.font.lineHeight.tight};
   `,
   bodyS: css`
      font-size: ${tokens.font.size.sm};
      font-weight: ${tokens.font.weight.normal};
      line-height: ${tokens.font.lineHeight.normal};
   `,
   bodyM: css`
      font-size: ${tokens.font.size.md};
      font-weight: ${tokens.font.weight.normal};
      line-height: ${tokens.font.lineHeight.normal};
   `,
   bodyL: css`
      font-size: ${tokens.font.size.lg};
      font-weight: ${tokens.font.weight.normal};
      line-height: ${tokens.font.lineHeight.normal};
   `,
};

export const mixins = {
   focusRing: css`
      &:focus {
         outline: none;
         border-color: ${theme.colors.border.focus};
         box-shadow: 0 0 0 2px ${rgba(theme.colors.border.focus, 0.2)};
      }
   `,

   disabled: css`
      &:disabled {
         background-color: ${theme.colors.bg.secondary};
         color: ${theme.colors.text.disabled};
         cursor: not-allowed;
      }
   `,

   hoverHighlight: css`
      cursor: pointer;
      transition: background-color ${tokens.transition.fast};

      &:hover {
         background-color: ${theme.colors.bg.secondary};
      }
   `,

   card: css`
      background-color: ${theme.colors.bg.primary};
      border: ${tokens.border.thin} ${theme.colors.border.default};
      border-radius: ${tokens.radius.md};
      box-shadow: ${tokens.shadow.sm};
   `,

   truncate: css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
   `,
};
